<template>
    <el-row :gutter="30"  class="mw-100 manage-sections-header" >
        
        <el-col :lg="24" :xs="24">
            <el-card>
                <el-tabs  tab-position="left">
                    <el-tab-pane  v-for="(item, index) in currentSectionsHeaderData.translates" :key="index" >
                        <template #label>
                            <span class="custom-tabs-label">
                                <span>
                                    {{$getLanguageName(item.languageID)}}
                                </span>
                            </span>
                        </template>
                        <el-form 
                            class="text-center font-24" 
                            ref="addSectionsHeaderRef"
                            :model="currentSectionsHeaderData"
                            :rules="currentSectionsHeaderDataRules"
                            label-position="top"
                        >
                            <el-row :gutter="30">
                                <el-col :lg="24" :xs="24">
                                    <el-form-item>
                                        <el-button type="primary" @click="manageSectionsHeader('addSectionsHeaderRef',index)" class="text-cap">
                                            <font-awesome-icon :icon="['fas', 'floppy-disk']" style="width:20px" class="mr-10" />
                                            save
                                        </el-button>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="24" :xs="24">
                                    <el-card class="h-100">
                                        <el-row :gutter="30">
                                            <el-col :lg="24" :xs="24">
                                                <el-form-item  label="title" :prop="`translates[${index}].title`" :class="$getLanguageName(item.languageID).toLowerCase() == 'عربي' ? 'text-right':''">
                                                    <el-input type="text" v-model="currentSectionsHeaderData.translates[index].title"></el-input>    
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="24" :xs="24">
                                                <el-form-item  label="description" :prop="`translates[${index}].description`" :class="$getLanguageName(item.languageID).toLowerCase() == 'عربي' ? 'text-right':''">
                                                    <el-input type="textarea" rows="4" v-model="currentSectionsHeaderData.translates[index].description"></el-input>    
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-card>
                                </el-col>
                                
                                
                            </el-row>
                        </el-form>
                    </el-tab-pane>
                </el-tabs>
            </el-card>
        </el-col>
    </el-row>
   
    
</template>

<script>
export default {
    data(){
        return {
           
            fileList:[],
            isAddSectionsHeader:true,
            fileUploaded:false,
            currentSectionsHeaderData:{},
            currentSectionsHeaderDataRules:{
                translates:this.$setTranslateRules(['title']),
            }
        };
    },
    computed:{
        cachedSectionsHeader(){
            return JSON.parse(localStorage.getItem('adminStore'))?.website?.settings?.sectionsHeaders?.currentSectionsHeader || {}
        }
    },
    mounted(){
        if (this.$route.params.id && this.$route.params.id == this.cachedSectionsHeader.id) {
            this.isAddSectionsHeader = false;
            this.currentSectionsHeaderData = JSON.parse(JSON.stringify(this.cachedSectionsHeader));
            this.currentSectionsHeaderData = this.converUpdatedObj(this.currentSectionsHeaderData);
            this.currentSectionsHeaderData.translates = this.$filterPublishedTranslates(this.currentSectionsHeaderData.translates);
           
        }else{
            this.$router.push({
                name:'manage-sections-header',
            })
            this.isAddSectionsHeader = true;
            this.currentSectionsHeaderData = this.initState()
            this.currentSectionsHeaderDataRules.imageBase64 = [
                {
                    required:true,
                    trigger:'blur',
                    message:'required field'

                }
            ]
        }
    },
    
    methods:{
        initState(){
            return {
             
                translates:this.$setTranslateKeys({
                    'description':'',
                    'title':'',
                }),
               
            }
        },
       
        async manageSectionsHeader(formName){
            let successForm = [];
            for (let index = 0; index < this.$refs[formName].length; index++) {
                const element = this.$refs[formName][index];
                element.validate(async (valid) => {
                    if (!valid) {
                        this.$message({
                            message:`please fill the data in the ${this.$getOrderName(index + 1)} tab `,
                            type:'info',
                            duration:5000,
                            showClose: true,
                        });
                    }
                }).then(data =>{
                    let indexOfIndex = successForm.indexOf(index);
                    if (data){
                        successForm.push(index);
                        if (successForm.length == this.$refs['addSectionsHeaderRef'].length){
                            this.manageSectionsHeaderAfterValidate()
                        }
                    }else{
                        if(indexOfIndex != -1) {
                            successForm.splice(indexOfIndex,1);
                        }
                    }
                })  
            }
           
            
            
            
            
            
        },
        async manageSectionsHeaderAfterValidate(){
            let clonedData = JSON.parse(JSON.stringify(this.currentSectionsHeaderData));
            delete clonedData.imageURL;
            
            
            const response = await this.$store.dispatch(this.isAddSectionsHeader ? 'addSectionsHeader':'editSectionsHeader',clonedData);
            if (response.data.status == 1) {
                this.$notify({
                    title:String(response.status),
                    message:response.data.message,
                    type:'success',
                });
                await this.$store.dispatch('getAllSectionsHeaders');
                this.$router.push({
                    name:'sections-headers-list'
                })
            }
        },
        onUploadImage(file){
            const FR = new FileReader();
            let module = this;
            FR.addEventListener("load", function(evt) {
                module.currentSectionsHeaderData.imageBase64 = evt.target.result;
            }); 
            this.currentSectionsHeaderData.imageURL =  URL.createObjectURL(file.raw);

            FR.readAsDataURL(file.raw);
        }, 
        handleRemoveImage(){
            this.currentSectionsHeaderData.imageURL = this.isAddSectionsHeader ? '' : this.cachedSectionsHeader.imageURL
        },   
      
        
        converUpdatedObj(oldObj){
            // Copy the object
            let newObj = Object.assign({}, oldObj);
            delete newObj.value;
            delete newObj.image2URL;
            return newObj
        }
    }
}
</script>
<style lang="scss">
    .manage-sections-header {
        .ck-editor {
            width:100%;
        }
    }
</style>